import React, { useMemo } from 'react';
import classNames from 'classnames';
import { applyDataAttr } from '@sovryn/ui';
import bannerDesktop from '../../../assets/images/Desktop_Banner_1.2.svg';
import bannerMobile from '../../../assets/images/Mobile_Banner.svg';
import { useWalletConnect } from '../../../hooks';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { ConnectedUserBanner } from './components/ConnectedUserBanner/ConnectedUserBanner';
export const DashboardWelcomeBanner = ({ openLOC, connectWallet, className, }) => {
    const { account } = useWalletConnect();
    const { isMobile } = useIsMobile();
    const banner = useMemo(() => (isMobile ? bannerMobile : bannerDesktop), [isMobile]);
    if (!account) {
        return (React.createElement("div", { className: classNames('flex justify-center cursor-pointer', className), onClick: connectWallet },
            React.createElement("img", Object.assign({ src: banner, alt: "welcome banner" }, applyDataAttr('zero-dashboard-banner')))));
    }
    return React.createElement(ConnectedUserBanner, { openLOC: openLOC });
};
